module.exports = __webpack_public_path__ + "static/media/callgage-gradient-logo.dcda643a.png";